import { useEffect, useState } from 'react';
import { Subscription } from 'rxjs';

import GameAPI from '../frontendServices/gameAPI';
import { NewRelic } from './useNewRelic';

function useReconnectFailed(
  gameAPI: GameAPI,
  gameId: string,
  tenantId: string,
  uid: string,
) {
  const [hasPoorInternetConnection, setHasPoorInternetConnection] = useState(false);
  useEffect(() => {
    let $sub: Subscription | undefined = undefined;
    if (gameAPI) {
      $sub = gameAPI?.$hasPoorInternet().subscribe({
        next: hasPoorInternet => {
          setHasPoorInternetConnection(hasPoorInternet);
        },

        error: error => {
          NewRelic()?.noticeError(error);
        },
      });
    }
    return () => {
      if ($sub) {
        $sub.unsubscribe();
      }
    };
  }, [gameAPI, gameId, tenantId, uid]);

  return {
    hasPoorInternetConnection,
  };
}

export default useReconnectFailed;
